"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOSRequests = void 0;
const Utils_1 = require("../Utils");
class TOSRequests {
    constructor() {
        this.VERSION_API_URL = "https://static.deako.com/tos";
        this.fetchCallbacks = [];
        if (TOSRequests.instance) {
            return TOSRequests.instance;
        }
        TOSRequests.instance = this;
    }
    getCurrentVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentVersion !== undefined) {
                return this.currentVersion;
            }
            const url = this.getTOSDataUrl("current_tos", "txt");
            const versionString = yield (0, Utils_1.wrapFetchText)(url);
            const [versionNumber] = versionString.split(".");
            this.currentVersion = versionNumber;
            return this.currentVersion;
        });
    }
    getTOS() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentTOS !== undefined) {
                return this.currentTOS;
            }
            if (this.fetchPromise === undefined) {
                const fetchFunc = () => __awaiter(this, void 0, void 0, function* () {
                    const currentVersion = yield this.getCurrentVersion();
                    const result = yield this.getTOSText(currentVersion);
                    this.currentTOS = result;
                    return result;
                });
                this.fetchPromise = this.wrapFetch(fetchFunc);
            }
            return new Promise((resolve) => {
                this.fetchCallbacks.push((result) => {
                    resolve(result);
                });
            });
        });
    }
    wrapFetch(fetchFunc) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield fetchFunc();
            this.provideResult(result);
            this.cleanUpFetch();
        });
    }
    provideResult(result) {
        for (const c of this.fetchCallbacks) {
            c(result);
        }
    }
    cleanUpFetch() {
        this.fetchPromise = undefined;
    }
    getTOSText(version) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getTOSDataUrl(version);
            return (0, Utils_1.wrapFetchText)(url);
        });
    }
    getTOSDataUrl(version, extension = "md") {
        return `${this.VERSION_API_URL}/${version}.${extension}`;
    }
}
exports.TOSRequests = TOSRequests;
//# sourceMappingURL=TOSRequests.js.map